<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-report-monthly-operator></table-report-monthly-operator>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableReportMonthlyOperator from './TableGrids/TableReportMonthlyOperator.vue'

export default {
    name: 'ReportMonthlyOperator',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableReportMonthlyOperator,
    },
    data() {
        return {
            page: {
                title: "Monthly Order Transactions",
            },
            breadcrumbs: [
                { text: "Monthly Order Transactions", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
